<template>
    <!--弹窗-->
    <el-dialog
        width="85%"
        class="plural"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        append-to-body
        top="5vh"
    >
        <el-form ref="form" :inline="true" class="query-form" size="mini">

            <el-form-item label="更新情况：" class="query-form-item" style="width: 310px;">
                <el-select v-model="query.finish_status" placeholder="请选择" size="mini">
                    <el-option label="全部" :value="undefined"></el-option>
                    <el-option label="待更新" :value="0"></el-option>
                    <el-option label="更新完成" :value="1"></el-option>
                    <el-option label="已变更" :value="2"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="广告组:" class="query-form-item" style="width: 220px;">
                <el-input style="width: 150px;" clearable v-model="query.ad_group_name"
                          placeholder="请输入广告组"></el-input>
            </el-form-item>

            <el-form-item label="类型：" class="query-form-item" style="width: 280px;">
                <el-select v-model="query.type" placeholder="请选择" size="mini">
                    <el-option label="全部" :value="undefined"></el-option>
                    <el-option label="定向广告" value="target_ad"></el-option>
                    <el-option label="关键词广告" value="keyword_ad"></el-option>
                    <el-option label="广告位" value="placement"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Teambition状态：" class="query-form-item">
                <el-select v-model="query.created_teambition_task_status" placeholder="请选择" size="mini">
                    <el-option label="全部" :value="undefined"></el-option>
                    <el-option label="待更新" :value="0"></el-option>
                    <el-option label="已更新" :value="1"></el-option>
                    <el-option label="更新失败" :value="-1"></el-option>
                    <el-option label="无需更新" :value="-2"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="queryList">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="list" size="mini" border height="700">
            <el-table-column prop="id" label="ID" align="center"/>
            <el-table-column label="类型" align="center" width="100">
                <template slot-scope="scope">
                    <div>{{
                            scope.row.type === 'target_ad' ? '定向广告' : scope.row.type === 'keyword_ad' ? '关键词广告' : '广告位'
                        }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="type_id" label="广告ID" width="130" align="center"/>
            <el-table-column prop="location" label="广告描述" min-width="180" align="center"/>
            <el-table-column prop="origin_value" label="原值" align="center"/>
            <el-table-column prop="new_value" label="新值" align="center"/>
            <el-table-column prop="asin_id" label="Asin ID" width="100" align="center"/>
            <el-table-column prop="shop_name" label="店铺" align="center" width="120"/>
            <el-table-column prop="campaign_name" label="广告活动" min-width="180" align="center"/>
            <el-table-column prop="ad_group_name" label="广告组" min-width="180" align="center"/>
            <el-table-column prop="created_time" label="创建时间" width="150" align="center"/>

            <el-table-column label="更新情况" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.finish_status == 0 ? '待更新' : scope.row.finish_status == 1 ? '更新完成' : '已变更' }}</div>
                </template>
            </el-table-column>

            <el-table-column prop="finish_time" label="更新完成时间" width="150" align="center"/>
            <el-table-column prop="finish_message" label="更新完成信息" width="180" align="center"/>

            <el-table-column label="Teambition状态" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{
                            scope.row.created_teambition_task_status == 0 ? '待更新' : scope.row.created_teambition_task_status == 1 ? '已更新' : scope.row.created_teambition_task_status == -1 ? '更新失败' : '无需更新'
                        }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="created_teambition_task_time" label="Teambition时间" width="150" align="center"/>
            <el-table-column prop="created_teambition_task_message" label="Teambition信息" width="120" align="center"/>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="query.total" background :current-page="query.page"
                       style="margin-top: 10px;display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                @click="handleClose">关 闭
            </el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'

export default {
    data() {
        return {
            id: undefined,
            loading: false,
            list: [],
            keyword: '',
            query: {
                page: 1,
                limit: 10,
                total: 0,
            },
            visible: false
        }
    },
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    methods: {
        showModal(id) {
            this.query = {
                page: 1,
                limit: 10,
                total: 0,
            }
            this.id = id
            this.queryList()
            this.visible = true

        },
        queryList() {
            this.query.page = 1
            this.getList()
        },
        getList() {
            this.loading = true
            this.query.unique_id = this.id
            api.optimize_acos_excel_list_optimize_acos_detail_list(this.query)
                .then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.list = res.data.list
                        this.query.total = res.data.total
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                })
                .catch(() => {
                    this.loading = false
                })
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        // 关闭弹窗
        handleClose() {
            this.visible = false
            this.list = []
            this.$emit('close-callback', false)
        }
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.plural {
    /deep/ .el-table__empty-block {
        border-bottom: 1px #ebeef5 solid;
    }

    /deep/ .el-dialog__body {
        padding-top: 0 !important;
    }
}
</style>
